import React from 'react';
import './style.css';
import { NavLink } from 'react-router-dom';
import Animation from '../Images/animation.svg';

export default function Leanding() {
    return(
        <React.Fragment>
            <div className="leanding">
                <div className="l_left">
                    <img src={Animation} alt="animation" draggable="false"/>
                </div>
                <div className="l_right">
                    <div className="title">
                        <h2>Solver<span>Js</span></h2>
                    </div>
                    <div className="pera">
                        <p>With web application all the time we face many problems to implement some logic, but in logic, we want some common mathematical applications like GCD, sum of all digits and this makes our implementation more complex hence If you want all these common math problems solved, then you can use solverjs. SolverJS are a combination of many common mathematical and some very used logic solutions.
                        </p>
                    </div>
                    <NavLink to="/docs"><button className="btn-primary">How To Use?</button></NavLink>
                </div>
            </div>
        </React.Fragment>
    );
}